import { render, staticRenderFns } from "./NotificationAppointmentRequested.vue?vue&type=template&id=3f5c018f&scoped=true&"
import script from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAppointmentRequested.vue?vue&type=style&index=0&id=3f5c018f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c018f",
  null
  
)

export default component.exports